@if (hasAvatar()) {
  <p-avatar pTooltip="{{user?.first_name && user?.last_name ? user!.first_name + ' ' + user!.last_name : user?.username}}" [size]="size" class="inner-avatar"
  [image]="avatarUrl()" shape="circle"></p-avatar>
}
@if (!hasAvatar()) {
  <p-avatar pTooltip="{{user?.first_name && user?.last_name ? user!.first_name + ' ' + user!.last_name : user?.username}}" [size]="size" class="inner-avatar"
  label="{{(user! | avatarLabel)}}" shape="circle"></p-avatar>
}
